import { Auth, API } from 'aws-amplify';

// Direct API endpoint (no proxy)
const API_NAME = 'api';

/**
 * Makes an API request via Amplify API
 * @param {string} method - HTTP method (GET, POST, PUT, DELETE)
 * @param {string} path - API path (e.g., /projects/123/participants)
 * @param {object} body - Request body (optional)
 * @returns {Promise<object>} - Response data
 */
export const corsProxyRequest = async (method, path, body = null) => {
  try {
    console.log(`corsProxy - Making ${method} request to ${path} via Amplify API`);
    console.log('corsProxy - Request body:', body);
    
    // Prepare request options
    const options = {};
    
    // Add body for non-GET requests
    if (body && method !== 'GET') {
      options.body = body;
    }
    
    try {
      // Make the request through Amplify API
      let response;
      
      switch (method.toUpperCase()) {
        case 'GET':
          console.log('corsProxy - Making GET request with options:', options);
          response = await API.get(API_NAME, path, options);
          break;
        case 'POST':
          response = await API.post(API_NAME, path, options);
          break;
        case 'PUT':
          response = await API.put(API_NAME, path, options);
          break;
        case 'DELETE':
          response = await API.del(API_NAME, path, options);
          break;
        default:
          throw new Error(`Unsupported method: ${method}`);
      }
      
      console.log('corsProxy - API response:', response);
      return response;
    } catch (apiError) {
      console.error('corsProxy - API call failed:', apiError);
      throw apiError;
    }
  } catch (error) {
    console.error('corsProxy - API request failed:', error);
    throw error;
  }
};

/**
 * Makes a GET request through the CORS proxy
 * @param {string} path - API path
 * @returns {Promise<object>} - Response data
 */
export const get = (path) => corsProxyRequest('GET', path);

/**
 * Makes a POST request through the CORS proxy
 * @param {string} path - API path
 * @param {object} body - Request body
 * @returns {Promise<object>} - Response data
 */
export const post = (path, body) => corsProxyRequest('POST', path, body);

/**
 * Makes a PUT request through the CORS proxy
 * @param {string} path - API path
 * @param {object} body - Request body
 * @returns {Promise<object>} - Response data
 */
export const put = (path, body) => corsProxyRequest('PUT', path, body);

/**
 * Makes a DELETE request through the CORS proxy
 * @param {string} path - API path
 * @returns {Promise<object>} - Response data
 */
export const del = (path) => corsProxyRequest('DELETE', path);

export default {
  get,
  post,
  put,
  delete: del
};